import { useRouter } from 'next/router'
import { useEffect, useLayoutEffect, useState } from 'react'

// Constants
import { BACK_REF_QUERY_KEY, BACK_REF_STORAGE_PREFIX, BACK_REF_TTL } from '@/constants/backRef'

// SSR 階段沒有 layout effect，避免 server render 警告
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

// 只接受站內相對路徑，避免 open redirect（`//` 與 `/\` 會被瀏覽器視為外部網址）
const isInternalPath = (path: string) => path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\')

// 讀取 query string 上的 backRef nonce，還原另開新分頁前的來源路徑
// isBackRefResolved 為 false 時表示尚未完成驗證，顯示端應留白避免先渲染錯誤文字
// https://tutorabc-org.atlassian.net/browse/SDC-2109
const useBackRef = () => {
  const router = useRouter()
  const [backRefPath, setBackRefPath] = useState<string | null>(null)
  const [isBackRefResolved, setIsBackRefResolved] = useState(false)

  useIsomorphicLayoutEffect(() => {
    if (!router.isReady) return
    try {
      const nonce = router.query[BACK_REF_QUERY_KEY]
      if (typeof nonce === 'string' && nonce) {
        const raw = localStorage.getItem(`${BACK_REF_STORAGE_PREFIX}${nonce}`)
        if (raw) {
          const record = JSON.parse(raw)
          if (
            typeof record?.from === 'string' &&
            typeof record?.ts === 'number' &&
            Date.now() - record.ts <= BACK_REF_TTL &&
            isInternalPath(record.from)
          ) {
            setBackRefPath(record.from)
          }
        }
      }
    } catch (e) {
      // localStorage 不可用或資料毀損時維持既有 fallback（Redux previousPage / 回商城）
    }
    setIsBackRefResolved(true)
  }, [router.isReady])

  return { backRefPath, isBackRefResolved }
}

export default useBackRef
